import { useEffect, useRef } from "react";
import { gameState } from "./gameStore";
import { POIS } from "./poi";

export default function Compass({ visitedIds }) {
  const arrowRef = useRef(null);
  const labelRef = useRef(null);

  useEffect(() => {
    let raf;
    const tick = () => {
      const next = POIS.find((p) => !visitedIds.current.has(p.id)) || POIS[POIS.length - 1];
      const [px, , pz] = next.position;
      const dx = px - gameState.position.x;
      const dz = pz - gameState.position.z;
      const bearing = Math.atan2(dx, dz) - gameState.facing;
      if (arrowRef.current) {
        arrowRef.current.style.transform = `rotate(${bearing}rad)`;
      }
      if (labelRef.current) {
        const allDone = visitedIds.current.size >= POIS.length;
        labelRef.current.textContent = allDone
          ? "ALL SECTIONS EXPLORED"
          : `${next.number} — ${next.label}`;
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [visitedIds]);

  return (
    <div
      data-testid="game-compass"
      className="pointer-events-none fixed top-6 left-1/2 z-40 flex -translate-x-1/2 flex-col items-center gap-1"
    >
      <div className="relative h-14 w-14 rounded-full border border-[#01FFFF]/40 bg-black/40 backdrop-blur-md">
        <div
          ref={arrowRef}
          className="absolute inset-0 flex items-center justify-center transition-transform duration-150"
          style={{ transformOrigin: "50% 50%" }}
        >
          <div
            className="h-0 w-0"
            style={{
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderBottom: "14px solid #01FFFF",
              filter: "drop-shadow(0 0 4px #01FFFF)",
              marginTop: "-8px",
            }}
          />
        </div>
      </div>
      <span
        ref={labelRef}
        className="font-mono text-[10px] tracking-[0.2em] text-[#8A9AAB] bg-black/40 px-2 py-0.5 backdrop-blur-md"
      />
    </div>
  );
}
